import React from "react";
import { useMetabaseReport } from "Hooks/useMetabaseReport";
import Iframe from "react-iframe";
import useStyles from "./styles";
import { MetabaseDashboardToken } from "generated/graphql";

export const UsageReport = ({ title }: { title: string }) => {
  const { iframeUrl, loading } = useMetabaseReport(MetabaseDashboardToken.Usage);
  const classes = useStyles();

  if (!iframeUrl || loading) {
    return null;
  }

  return (
    <Iframe
      className={classes.container}
      width="80%"
      height="1000"
      display="initial"
      position="absolute"
      url={iframeUrl}
      title={title}
    />
  );
};
